import axios from 'axios';

const settings = window.APP_SETTINGS;

const getExpertDicomJsonApiEndPointUrl = (studyNo) =>
  `${settings.DICOM_API_URL}/dicom/expert-study-json&studyId=${studyNo}`;

export const getPartDicomCdsDownloadUrls = async (orderId, partNumber) => {
  try {
    const response = await axios.get(
      `${settings.EXPERT_API_BASE_URL}/orders/${orderId}/part/${partNumber}/dicoms/url`
    );
    return response.data;
  } catch (error) {
    console.error('Error getting DICOM CD download URL:', error);
    throw error;
  }
};

export const markDicomAsViewed = async (orderId, dicomId) => {
  try {
    await axios.post(`${settings.EXPERT_API_BASE_URL}/orders/${orderId}/dicoms/${dicomId}/mark-as-viewed`);
    return true;
  } catch (error) {
    console.error('Error marking dicom as viewed:', error);
    return false;
  }
};

export const openDicomViewer = (studyNo) => {
  const dicomViewerUrl = `${
    settings.DICOM_VIEWER_URL
  }/viewer?url=${getExpertDicomJsonApiEndPointUrl(studyNo)}`;

  const windowName = `DicomViewerWindow-${studyNo}`;
  const windowObject = window.open(dicomViewerUrl, windowName);
  const isOpen = !!windowObject;

  if (isOpen) {
    windowObject.focus();
  }

  return {
    isOpen,
    windowObject,
    windowName,
    studyNo,
  };
};
